import React, { Component } from "react";

import ColourModal from "../../../modal/toolbar/adjust/hsl/Colour";

export default class Colour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showColourModal: false,
      selectedColor: { id: 1, value: "rgba(255,12,12, 1)" },
    };
  }

  render() {
    let { selectedColor } = this.state;
    return (
      <>
        {/* //TODO: Hide for now, display later */}
        {/* <div className="colour widget">
          <button
            type="button"
            className="btn btn-dark"
            onClick={() => {
              this.setState((prevState) => ({
                showColourModal: !prevState.showColourModal,
              }))
            }}
          >
            Colour
            <span
              style={{
                backgroundColor: selectedColor.value, // the value has to change dynamically
              }}
            ></span>
          </button>
        </div> */}

        <ColourModal
          show={this.state.showColourModal}
          selectedColor={this.state.selectedColor}
          onColorSelected={(color) =>
            this.setState({ selectedColor: color }, () => {
              this.props.onColorSelected(color);
            })
          }
          onHide={() => this.setState({ showColourModal: false })}
        />
      </>
    );
  }
}
